<template>
    <div class="row" v-if="viewCalendarSection">
        <div class="col-lg-12 mb-4">
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap">
                        <div class="box-ttl">Calendar</div>

                    </div>
                    <div class="buttons--row buttons--row-3 mb-3">
                        <div class="inner-wrap inner-wrap-one">
                            <div class="date-info">
                                <div>
                                    {{ dateForTimeSheets(currentDate) }}
                                </div>
                            </div>
                            <div class="search--block" style="flex-grow: 1">
                                <button
                                    class="search--block-btn"
                                    type="submit"
                                    @click="searchEvents"
                                >
                                    <img src="/img/svg/icons-search.svg" alt="">
                                </button>
                                <input type="search"
                                       class="search--block-txt"
                                       placeholder="Search by Title"
                                       v-model="search"
                                       @input="delayedSearch"
                                />
                            </div>
                        </div>
                        <div class="calendar-month-wrap-btns">
                            <div class="inner-wrap inner-wrap-btns">
                                <button
                                    v-show="showSearchResult"
                                    class="btn btn--outline-primary btn--middle m-w-116"
                                    @click="backToGridCalendar"
                                >
                                    Back to Main
                                </button>
                                <a
                                    href="/master-admin/calendar/event/add"
                                   class="btn btn--outline-primary btn--middle m-w-116"
                                >
                                    Add Event
                                </a>
                                <button
                                    v-show="createCalendars"
                                    class="btn btn--outline-primary btn--middle m-w-116"
                                    @click="showCustomModal('calendar', 'new')"
                                >
                                    Add Calendar
                                </button>

                                <CalendarSettingsModal
                                    :modal-id="getCustomModalId('calendar', 'new')"
                                    :modal-title="`Create New Calendar`"
                                />

                                <a
                                    v-show="editWorkdaySettings"
                                    href="/master-admin/calendar/settings"
                                    class="btn btn--outline-primary btn--middle m-w-156"
                                >
                                    Workday settings
                                </a>

                            </div>
                        </div>

                    </div>
                    <div class="buttons--row buttons--row-3 mb-3">
                        <div class="calendar-type-block">
                            <div
                                class="calendar-item"
                                v-for="calendar in listOfCalendars"
                                :key="calendar.id"
                            >
                                <div class="d-flex align-items-center">
                                    <div class="form-check">
                                        <input
                                            class="form-check-input-checkbox"
                                            type="checkbox"
                                            :name="calendar.name"
                                            :value="calendar.id"
                                            :id="calendar.id"
                                            v-model="selectedCalendars"
                                        >
                                        <label class="form-check-label" for="mon-mor"></label>
                                    </div>
                                    <div
                                        class="color mr-2"
                                        :class="'background-color--c' + (calendar.color)"
                                    ></div>
                                    <div class="name">{{ calendar.name }}</div>
                                </div>

                                <div class="d-flex align-items-center">
                                    <a
                                        v-if="calendar.isDeletable && deleteCalendars"
                                        class="remove"
                                        @click="showDeleteModal(calendar.id)"
                                    >
                                        <img src="/img/close.png" alt="delete">
                                    </a>

                                    <ActionModal confirm-text="Yes" reject-text="No"
                                                 :modalId="getDeleteModalId(calendar.id)"
                                                 @confirm="deleteCalendar(calendar.id)">
                                        <template #body>
                                            <div class="text-center mb-4">
                                                <h4>
                                                    Are you sure you want <br> to delete this
                                                    calendar?
                                                </h4>
                                            </div>
                                        </template>
                                    </ActionModal>


                                    <a class="dots"
                                       v-show="editCalendars"
                                       @click="showCustomModal('calendar', calendar.id)"
                                    >
                                        <img src="/img/dots-menu.svg" alt="settings">
                                    </a>

                                    <CalendarSettingsModal
                                        :modal-id="getCustomModalId('calendar', calendar.id)"
                                        :modal-title="`Calendar Settings`"
                                        :calendar-info="calendar"
                                        @update-calendar="getListOfCalendars"
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="calendar-wrap">
                        <CalendarSearch
                            v-if="showSearchResult"
                            :found-events="foundEvents"
                            @update-list="searchEvents"
                        />

                        <CalendarGrid
                            :selected-calendars="selectedCalendars"
                            v-if="!showSearchResult && !loading"
                            :view="calendarView"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import CalendarGrid from "./CalendarGrid.vue";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import CalendarSettingsModal from "./CalendarSettingsModal.vue";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import CalendarService from "./services/CalendarService";
import CalendarSearch from "./CalendarSearch.vue";
import _ from "lodash";

export default {

    name: "MainCalendar",
    components: {
        CalendarSearch,
        ActionModal,
        CalendarSettingsModal,
        CalendarGrid
    },
    props: {
        viewCalendarSection: Boolean,
        createCalendars: Boolean,
        editCalendars: Boolean,
        deleteCalendars: Boolean,
        editWorkdaySettings: Boolean,
    },
    mixins: [DateConverter, ModalHandler],
    data() {
        return {
            calendarView: null,
            loading: true,
            search: null,
            currentDate: new Date(),
            listOfCalendars: [],
            selectedCalendars: [],
            foundEvents: [],
            showSearchResult: false
        }

    },
    methods: {
        checkSelectedCalendars() {
            this.selectedCalendars = JSON.parse(localStorage.getItem("checkedCalendars"));
            if (!this.selectedCalendars) {
                this.selectedCalendars =  []
                this.listOfCalendars.map(calendar => {
                    this.selectedCalendars.push(calendar.id)
                })
            }
            this.loading = false
        },
        backToGridCalendar() {
            this.showSearchResult = false
            this.search = null
        },
        delayedSearch: _.debounce(function() {
            this.searchEvents()
        }, 500),

        async searchEvents() {
            try {
                const { data : response } = await CalendarService.getEventsForSearch(this.search)
                this.foundEvents = response
                this.showSearchResult = this.foundEvents.length > 0;
            } catch {

            }
        },
        async deleteCalendar(id) {
            this.$showLoadingMessage()
            this.listOfCalendars = this.listOfCalendars.filter((calendar) => calendar.id !== id)
            try {
                await CalendarService.deleteCalendarItem(id)
                this.$showSuccessMessageDelete();
            } catch (error) {
                this.$showErrorMessage('The calendar was not deleted. Please reload page and try again');
            }
        },
        async getListOfCalendars() {
            try {
                const {data: response} = await CalendarService.getCalendarList()
                this.listOfCalendars = response
                this.checkSelectedCalendars()
            } catch (e) {
                console.error(e)
            }
        },
    },
    mounted() {
        const calendarView = localStorage.getItem("calendarView")
        if (!calendarView) {
            this.calendarView = 'dayGridMonth'
        } else {
            this.calendarView = calendarView
        }
        this.getListOfCalendars()
    }

}
</script>

<style scoped>


</style>
